import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDataWAuth } from "../../../utils/api-service";
import { DROPDOWNS_URI } from "../../../constants/constant";

export const fetchDropdowns = createAsyncThunk(
  "shared/fetchDropdowns",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDataWAuth(DROPDOWNS_URI);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch dropdowns");
    }
  }
);

const initialState = {
  dropdowns: {
    countries: [],
    extensionTypes: [],
    requestStatus: [],
    countryCode: [],
  },
  loading: false,
  error: null,
  selectedCountry: null,
  selectedExtensionType: null,
};

const sharedExtensionSlice = createSlice({
  name: "sharedExtension",
  initialState,
  reducers: {
    setSelectedCountry: (state, action) => {
      state.selectedCountry = action.payload;
    },
    setSelectedExtensionType: (state, action) => {
      state.selectedExtensionType = action.payload;
    },
    clearFilters: (state) => {
      state.selectedCountry = null;
      state.selectedExtensionType = null;
    },
    clearSharedError: (state) => {
      state.error = null;
    },
    resetShared: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDropdowns.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDropdowns.fulfilled, (state, action) => {
        state.loading = false;
        state.dropdowns.countries = Object.keys(action.payload?.country || {});
        state.dropdowns.countryCode = Object.entries(action.payload?.country || {});
        state.dropdowns.extensionTypes = action.payload?.extensionType || [];
        state.dropdowns.requestStatus = (action.payload?.requestStatusList || []).map((res) =>
          res?.replaceAll("_", " ")
        );
      })
      .addCase(fetchDropdowns.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setSelectedCountry,
  setSelectedExtensionType,
  clearFilters,
  clearSharedError,
  resetShared,
} = sharedExtensionSlice.actions;

export default sharedExtensionSlice.reducer;
